(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('product-gallery').forEach((gallery) => {
      const form = document.forms[gallery.getAttribute('form')];
      if (!form) return;

      form.addEventListener('variant:change', (event) => {
        const variant = event.detail?.variant;
        if (!variant) return;
        const variantId = String(variant.id);
        const currentLocale = gallery.dataset.locale || '';

        const items = Array.from(gallery.querySelectorAll('.product-gallery__media'));
        const newFiltered = [];

        items.forEach((item, index) => {
          const alt = item.getAttribute('data-variant-alt') || '';
          let shouldHide = false;

          // Pass 1: locale filter
          if (alt.includes('[nl]') && currentLocale !== 'nl') {
            shouldHide = true;
          } else if (alt.includes('[en]') && currentLocale === 'nl') {
            shouldHide = true;
          }

          // Pass 2: variant filter
          if (!shouldHide && alt.includes('#')) {
            const tokens = alt.replace(/^#/, '').split('#').map(s => s.trim());
            if (!tokens.includes(variantId)) shouldHide = true;
          }

          item.hidden = shouldHide;
          if (shouldHide) newFiltered.push(index + 1);
        });

        gallery.setAttribute('filtered-indexes', JSON.stringify(newFiltered));

        const detail = { filteredIndexes: newFiltered.map(i => i - 1) };
        gallery.querySelectorAll('media-carousel').forEach(c =>
          c.dispatchEvent(new CustomEvent('carousel:filter', { detail }))
        );
        gallery.querySelectorAll('page-dots').forEach(d =>
          d.dispatchEvent(new CustomEvent('control:filter', { detail }))
        );

        const featuredId = variant.featured_media?.id;
        if (featuredId) {
          const targetIndex = items.findIndex(el =>
            el.getAttribute('data-media-id') === String(featuredId) && !el.hidden
          );
          if (targetIndex !== -1) {
            gallery.querySelectorAll('media-carousel').forEach(c => {
              if (typeof c.select === 'function') c.select(targetIndex, { animate: false });
            });
          }
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-rating"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bareTpInit) return;
    window.__bareTpInit = true;

    function scrollToReviews(e) {
      var w = e.target.closest && e.target.closest('.trustpilot-widget');
      if (!w) return;
      e.preventDefault();
      var t = document.getElementById('reviews_wraper') || document.getElementById('reviews_wrapper');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    document.addEventListener('click', scrollToReviews, true);

    function reload(node) {
      if (!node || node.nodeType !== 1) return;
      var widgets = node.matches && node.matches('.trustpilot-widget')
        ? [node]
        : Array.prototype.slice.call(node.querySelectorAll ? node.querySelectorAll('.trustpilot-widget') : []);
      widgets.forEach(function (el) {
        if (el.querySelector('iframe')) return;
        if (window.Trustpilot && window.Trustpilot.loadFromElement) {
          window.Trustpilot.loadFromElement(el, true);
        }
      });
    }

    var mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(reload);
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__stickyAtcListenersRegistered) return;
    window.__stickyAtcListenersRegistered = true;

    document.addEventListener('change', function(e) {
      if (e.target.type !== 'radio') return;

      const stickyBar = e.target.closest('.sticky-atc');
      if (!stickyBar) return;

      const formId = stickyBar.dataset.formId;
      if (!formId) return;

      const optionPosition = e.target.dataset.optionPosition;
      const optionValueId = e.target.value;

      const mainRadio = document.querySelector(
        'input[type="radio"][form="' + formId + '"][data-option-position="' + optionPosition + '"][value="' + CSS.escape(optionValueId) + '"]'
      );

      if (mainRadio && !mainRadio.checked) {
        mainRadio.checked = true;
        mainRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    document.addEventListener('variant:change', function(e) {
      const stickyBar = document.querySelector('.sticky-atc[data-form-id="' + e.detail.formId + '"]');
      if (!stickyBar) return;

      const variant = e.detail.variant;
      if (!variant) return;

      stickyBar.querySelectorAll('input[type="radio"]').forEach(function(radio) {
        const position = radio.dataset.optionPosition;
        const isMatch = radio.dataset.optionValueName === variant['option' + position];
        radio.checked = isMatch;
        radio.closest('.color-swatch').classList.toggle('is-selected', isMatch);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
